import { Injectable } from '@angular/core';

import { UserService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { InstaPromoLocalStorageModel } from '../model/insta-promo-local-storage.model';
import { InstaPromoModel } from '../model/insta-promo.model';

@Injectable({
    providedIn: 'root',
})
export class UserActionService {
    private pauseStoryBehaviourSubject = new BehaviorSubject<any>(null);
    pauseStoryObservable: Observable<boolean> = this.pauseStoryBehaviourSubject.asObservable();
    private changePromoStatusBehaviourSubject = new BehaviorSubject<any>(null);
    changePromoStatusObservable: Observable<boolean> = this.changePromoStatusBehaviourSubject.asObservable();
    private videoPresentBehaviourSubject = new BehaviorSubject<any>(null);
    videoPresentObservable: Observable<boolean> = this.videoPresentBehaviourSubject.asObservable();
    private videoProgressBehaviourSubject = new Subject<number>();
    videoProgressObservable: Observable<number> = this.videoProgressBehaviourSubject.asObservable();
    videoMuteBehaviourSubject = new BehaviorSubject<string>('');
    videoMuteObservable: Observable<string> = this.videoMuteBehaviourSubject.asObservable();
    muteVideo: string = 'muted';
    storyPaused: boolean = false;
    storyHasVideo: boolean = false;
    instaPromoList: InstaPromoModel[];

    constructor(private user: UserService) {}

    pauseStory(pauseStoryTrigger: boolean) {
        this.storyPaused = pauseStoryTrigger;
        this.pauseStoryBehaviourSubject.next(pauseStoryTrigger);
    }

    changePromoStatus(promoStatusObject: any) {
        this.changePromoStatusBehaviourSubject.next(promoStatusObject);
    }

    videoPresentStatus(isVideoPresent: boolean) {
        this.videoPresentBehaviourSubject.next(isVideoPresent);
    }

    videoProgressStatus(videoProgress: number) {
        this.videoProgressBehaviourSubject.next(videoProgress);
    }

    pauseVideo() {
        let video = <HTMLVideoElement>document.getElementById('casino-promoinstastory-video');
        let stream: HTMLMediaElement = {} as HTMLMediaElement;
        if (!video) stream = document.querySelector('#casino-promoinstastory-cmsvideo stream') as HTMLMediaElement;
        if (video) {
            if (!video.paused) {
                video.pause();
            }
        } else if (stream) {
            if (!stream.paused) {
                stream.pause();
            }
        }
    }

    playVideo() {
        let video = <HTMLVideoElement>document.getElementById('casino-promoinstastory-video');
        let stream: HTMLMediaElement = {} as HTMLMediaElement;
        if (!video) stream = document.querySelector('#casino-promoinstastory-cmsvideo stream') as HTMLMediaElement;
        if (video) {
            if (video.paused) video.play();
        } else if (stream) {
            if (stream.paused) stream.play();
        }
    }

    writeGamingStoriesArray(instaPromoLocalStorageArray: InstaPromoLocalStorageModel[]) {
        if (this.user.isAuthenticated) {
            localStorage.setItem('gamingStoriesPromoViewedState_' + this.user.username, JSON.stringify(instaPromoLocalStorageArray));
        } else {
            localStorage.setItem('gamingStoriesPromoViewedState', JSON.stringify(instaPromoLocalStorageArray));
        }
    }

    readGamingStoriesArray() {
        let instaPromoArrayFromLocalStorage: any;
        if (this.user.isAuthenticated) {
            instaPromoArrayFromLocalStorage = JSON.parse(localStorage.getItem('gamingStoriesPromoViewedState_' + this.user.username)!);
        } else {
            instaPromoArrayFromLocalStorage = JSON.parse(localStorage.getItem('gamingStoriesPromoViewedState')!);
        }
        return instaPromoArrayFromLocalStorage;
    }
}
